<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">实名认证</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">个人实名认证</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">个人实名认证</div>
      </div>
      <div class="panel-body">
        <div class="step-bar-triple step-bar-outer clearfix z-textAlign-center z-margin-bottom-25-precent">
          <div :class="{'step--current':steps === 'first'}" class="step-bar step-bar-begin">
            <div class="step-colored">
							<span>
								① 填写认证资料
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'second'}" class="step-bar step-bar-center">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								② 确认认证信息
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'three'}" class="step-bar step-bar-end">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								③ 实名认证完成
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
        </div>
        <el-form label-position="right" class="auth-form" :rules="rules" ref="ruleForm" label-width="180px" :model="authForm">
          <el-form-item label="手机号码" prop="name">
            <el-input v-model="authForm.phone" :disabled="true" style="width: 330px;"></el-input>
            <br>
            <p>请确认该手机号码是<span class="z-color-88-orange">您本人所有</span>，否则无法验证通过。</p>
          </el-form-item>
          <el-form-item label="真实姓名" required>
            <el-input v-model="authForm.name"></el-input>
            <br>
            <p>请填写您本人的 <span class="z-color-88-orange">真实姓名</span>，否则无法验证通过。</p>
          </el-form-item>
          <el-form-item label="身份证号码" required>
            <el-input v-model="authForm.cardno"></el-input>
            <br>
            <p>请填写您本人的 <span class="z-color-88-orange">真实身份证号码</span>，否则无法验证通过</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="border-radius: 0" @click="submitForm">下一步</el-button>
            <el-button type="info" plain style="border-radius: 0" @click="back">返回上一步</el-button>
          </el-form-item>
        </el-form>
        <div class="alert-warn-lg clearfix">
          <div class="tip-title">
            温馨提示：
          </div>
          <div class="tips-container">
            <div class="tips-content">
              <div>
                <p>1. 无论是否认证成功系统每次收取1元（测试期0.3元）的认证手续费。因为每次认证系统都会向国家认证中心通过API接口实时查询，此手续费为国家认证中心查询接口的费用。</p>
                <p>2. 请确保姓名、身份证号码完全正确，请勿使用他人身份信息进行认证，否则会认证失败</p>
                <p>3. 注册手机号必须属本人所有，请勿使用他人手机进行注册，否则认证会失败</p>
                <p>4. 三丰云会加密保存您的认证资料，绝不会泄露用户隐私，请放心认证</p>
                <p>5. 所填写资料仅用于实名认证，不会开通其他任何附加服务，三丰云工作人员不会向您索要短信验证码，谨防上当</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
    <!--blackpink-->
    <div v-if="dialogShadow" class="dialogShadow"></div>
    <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd v-if="info == 'SMRZ_ERR'" class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" >实名审核失败！请确保您的手机号实名认证和姓名、身份证一致！</span>
        <p class="z-textAlign-center">
          <a href="/help/content_1147.html" target="_blank" class="z-color-a z-font-size-15" style="margin-left: 2rem">查看认证失败的原因以及如何解决</a>
        </p>
      </dd>
      <dd v-if="info != 'SMRZ_ERR'" class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" >{{info}}</span>
        <p class="z-textAlign-center">
          <router-link to="/caiwu" class="z-color-a z-font-size-15" style="display: inline-block">点击充值</router-link>
        </p>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  export default {
    data () {
      return {
        dialogLoading:false,
        dialogShadow:false,
        steps:'first',
        cert_state:Number,
        authForm:{
          phone:'',
          name:'',
          cardno:''
        },
        rules: {
          name: [

          ],
        },
        msg:'',
        info:''
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.getState()
      this.getPhone()
    },
    methods:{
      async getState() {
        let data = 'cmd=smrz_info'
        let {vueData, state} = await userService.transformToVue('smrzInfo','POST',data)
        if(vueData.response == 200 ) {
          this.cert_state = vueData.cert_state
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async getPhone() {
        let data = 'cmd=userinfo'
        let {vueData, state} = await userService.transformToVue('userInfo','POST',data)
        if(vueData.response == 200 ) {
          this.authForm.phone = vueData.msg.ID_Mobile
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submitForm() {
        MessageBox.confirm('该操作将从您的帐户中扣除0.3元的认证费用,确定要提交吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=smrz_p'+
            '&phone='+ this.authForm.phone +
            '&name='+ this.authForm.name +
            '&cardno='+ this.authForm.cardno
          this.dialogLoading = true
          let {vueData, state} = await userService.transformToVue('smrzInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {
                self.$router.push('/auth')
              }})
          }else {
            this.dialogLoading = false
            if(vueData.msg === 'SMRZ_ERR' || vueData.msg.indexOf('余额不足') != -1){
              this.info = vueData.msg
              this.dialogShadow = true
            }else {
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }
        }).catch(() => {

        });
      },
      back(){
        this.$router.push('/auth')
      },
      clickBtn() {
        this.dialogShadow = false
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .auth-form .el-input {
    width: 440px;
  }
  .step-bar {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    float: left;
    width: 33%;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #fff;
  }
  /* 父容器添加，变为3或4或5个步骤，triple是3,quadra是4，penta是5*/
  .step-bar-triple .step-bar {
    width: 33.3%;
  }
  .step-bar-quadra .step-bar {
    width: 25%;
  }
  .step-bar-penta .step-bar {
    width: 20%;
  }
  .step-bar-begin {
    padding-right: 18px;
  }
  .step-bar-center {
    padding: 0 18px;
  }
  .step-bar-end {
    padding-left: 18px;
  }
  .step-colored {
    background-color: #7fddff;
  }
  /*.step-prefix {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -16px;
  }
  .step--current .step-prefix {
    background: url(img/uc/step_complete.png) no-repeat center;
    vertical-align: middle;
    !* 字体隐藏，由于模板中控制text-hide类比较复杂，这里使用step--current统一控制样式*!
    border: 0;
    background-color: transparent;
    color: transparent;
    font: 0/0 a;
    text-shadow: none;
  }
  .step--current.step--failed .step-prefix {
    background-image: url(img/uc/step_failed.png);
  }
  .step--current.step--dealing .step-prefix {
    background-image: url(img/uc/step_waiting.png);
  }*/
  .step--current .step-colored {
    background-color: #00aaff;
    color: #fff;
  }
  .step--completed .step-colored {
    background-color: #7fddff;
    color: #fff;
  }
  .step-arrow-left,
  .step-arrow-right {
    position: absolute;
    top: 0;
    border: 18px solid transparent;
    border-left-color: #7fddff;
  }
  .step-arrow-left {
    left: -8px;
    border: 18px solid #7fddff;
    border-left-color: transparent;
  }
  .step-arrow-right {
    right: -18px;
  }
  .step--current .step-arrow-left {
    border-color: #00aaff;
    border-left-color: transparent;
  }
  .step--current .step-arrow-right {
    border-left-color: #00aaff;
  }
  /* 对当前步骤之后的所有步骤设置灰色样式 */
  .step--current ~ .step-bar .step-colored {
    background-color: #f2f2f2;
    color: #636566;
  }
  .step--current ~ .step-bar .step-arrow-left {
    border-color: #f2f2f2;
    border-left-color: transparent;
  }
  .step--current ~ .step-bar .step-arrow-right {
    border-left-color: #f2f2f2;
  }
  .alert-warn-lg .tip-title {
    margin-top: 50px;
    position: relative;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-left: 10px;
    font-weight: bold;
    color: #ff6600;
    font-size: 14px;
  }
  .alert-warn-lg .tip-title:after {
    position: absolute;
    bottom: -1px;
    left: 0;
    content: "";
    width: 80px;
    height: 2px;
    background: #ff6600;
  }
  .tips-container {
    float: left;
  }
  .tips-content {
    padding-top: 20px;
    font-size: 12px;
    color: #636566;
  }
  .tips-content > div {
    overflow: hidden;
  }
  .tips-content p {
    margin: 0 0 15px;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>




// WEBPACK FOOTER //
// src/pages/user/personalAuth.vue